import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';
import { DateTime } from 'luxon';

const BSLASinkholesLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        title: 'Sinkholes (FDEP)',
        url: 'https://ca.dep.state.fl.us/arcgis/rest/services/OpenData/FGS_SUBSIDENCE/MapServer/0',
        visible: false,
        popupTemplate: {
            outFields: ['*'],
            title: 'Sinkholes (FDEP)',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');

                const size = `${atts.SINLNGTH ?? 'N/A'}L x ${atts.SINWIDTH ?? 'N/A'}W x ${atts.SINDEPTH ?? 'N/A'}D`;

                const content = (
                    <React.Fragment>
                        <BSLAPopupItemComponent label="Date of Reported Event" value={atts.EVENT_DATE ? DateTime.fromMillis(atts.EVENT_DATE).toFormat('MMM dd, yyyy') : 'N/A'} />
                        <BSLAPopupItemComponent label="Reference Number" value={atts.REF_NUM} />
                        <BSLAPopupItemComponent label="County" value={atts.COUNTY} />
                        <BSLAPopupItemComponent label="Accuracy" value={atts.ACCURACY} />
                        <BSLAPopupItemComponent label="Repair Status" value={atts.REPAIR_S} />
                        <BSLAPopupItemComponent label="Soil Type" value={atts.SOILTYPE ?? 'UNKNOWN'} />
                        <BSLAPopupItemComponent label="Size" value={size} />
                        <div className="mt-3">
                            <BSLAExternalLinkComponent href="https://floridadep.gov/fgs/sinkholes" />
                        </div>
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLASinkholesLayer;
